import { render, staticRenderFns } from "./ChartBox.vue?vue&type=template&id=b6f26c8e&scoped=true&"
import script from "./ChartBox.vue?vue&type=script&lang=js&"
export * from "./ChartBox.vue?vue&type=script&lang=js&"
import style0 from "./ChartBox.vue?vue&type=style&index=0&id=b6f26c8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f26c8e",
  null
  
)

export default component.exports